<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
        >
          Add Booking
        </v-card-title>
        <v-container grid-list-sm class="pa-4">
          <v-layout align-center row wrap>

            <slot name="CaseAndAmount"
              :casesList="casesList"
              :selectedCase="selectedCase"
              :amount="amount"
            ></slot>

            <slot name="ItemsSelection"
              :selectedItemType="selectedItemType"
              :inventoriesList="inventoriesList"
              :servicesList="servicesList"
              :caseManagersList="caseManagersList"
              :selectedInventory="selectedInventory"
              :selectedService="selectedService"
              :selectedCaseManager="selectedCaseManager"
              :amount="amount"
            ></slot>

            <v-flex xs6 align-center justify-space-between>
              <v-menu
                v-model="menuDateStart"
              >
                <v-text-field
                  v-model="dateStart"
                  slot="activator"
                  label="Select start date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="dateStart" reactive></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6 align-center justify-space-between>
              <v-menu
                :close-on-content-click="false"
                v-model="menuTimeStart.state"
              >
                <v-text-field
                  v-model="timeStart"
                  slot="activator"
                  label="Select start time"
                  prepend-icon="alarm"
                  readonly
                ></v-text-field>
                <v-time-picker v-model="timeStart"></v-time-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6 align-center justify-space-between>
              <v-menu
                v-model="menuDateEnd"
              >
                <v-text-field
                  v-model="dateEnd"
                  slot="activator"
                  label="Select end date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="dateEnd" reactive></v-date-picker>
              </v-menu>
            </v-flex>

              <v-flex xs6 align-center justify-space-between>
              <v-menu
                :close-on-content-click="false"
                v-model="menuTimeEnd.state"
              >
                <v-text-field
                  v-model="timeEnd"
                  slot="activator"
                  label="Select end time"
                  prepend-icon="alarm"
                  readonly
                ></v-text-field>
                <v-time-picker v-model="timeEnd" ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn color="primary" @click="saveNew">Save</v-btn>
          <v-btn flat @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import schedulesAPI from '@/api/resources/schedules'
  import AppMainDialog from '@/components/AppMainDialog'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import addButtonMixins from '@/mixins/AddButton'
  import bookingsMixins from '@/mixins/Bookings'
  import consts from '@/config/consts'

  var currentDate = new Date().toISOString().split('T')[0]

  export default {
    components: { AppMainDialog },
    mixins: [ addButtonMixins, bookingsMixins, itemTypesMixins ],
    data () {
      return {
        resources: 'schedules',
        dialog: false,
        dialogMessage: '',
        dialogOpen: false,
        casesList: [],
        inventoriesList: [],
        servicesList: [],
        caseManagersList: [],
        selectedInventory: { id: 0 },
        selectedService: { id: 0 },
        selectedCaseManager: { id: 0 },
        selectedCase: { id: null },
        amount: { number: 0 },
        dateStart: currentDate,
        dateEnd: currentDate,
        timeStart: null,
        timeEnd: null,
        menuDateStart: false,
        menuDateEnd: false,
        menuTimeStart: { state: false },
        menuTimeEnd: { state: false },
        selectedItemType: { id: consts.schedules.INVENTORY_TYPE_ID }
      }
    },
    watch: {
      timeStart (newVal) {
        this.checkIfMinutesSelectedAndCloseTimePopup(newVal, this.menuTimeStart)
      },
      timeEnd (newVal) {
        this.checkIfMinutesSelectedAndCloseTimePopup(newVal, this.menuTimeEnd)
      }
    },
    computed: {
      itemId () {
        return this.itemTypeToItemIDMap[this.selectedItemType.id].id
      },
      dateStartString () {
        return this.dateStart + ' ' + this.timeStart
      },
      dateEndString () {
        return this.dateEnd + ' ' + this.timeEnd
      }
    },
    methods: {
      checkIfMinutesSelectedAndCloseTimePopup (timeStr, timePopupModel) {
        if (timeStr.indexOf(':') !== -1) {
          timePopupModel.state = false
        }
      },
      saveNew () {
        let payload = {
          cases_id: this.selectedCase.id,
          schedule_start: this.dateStartString,
          schedule_end: this.dateEndString
        }

        // if selectedCase == null then this is lead saving; else this is booking saving
        if (this.selectedCase.id === null &&
            this.selectedInventory.id > 0 &&
            this.palbearersAmount > 0
            ) {
          // book palbearers with casemanager
          payload.item_id = this.selectedCaseManager.id
          payload.item_type = this.caseManagerTypeID
          payload.amount = 1

          schedulesAPI.saveSchedule(payload).then(() => {
            payload.item_id = this.selectedInventory.id
            payload.item_type = this.serviceTypeID
            // payload.item_type = this.inventoryTypeID
            payload.amount = this.palbearersAmount

            schedulesAPI.saveSchedule(payload).then(this.saveNewSuccess, this.saveNewError)
          }, this.saveNewError)
        } else {
          payload.item_id = this.selectedService.id
          payload.item_type = this.serviceTypeID
          // payload.item_type = this.selectedItemType.id
          payload.amount = 1
          // payload.amount = this.amount.number

          schedulesAPI.saveSchedule(payload).then(this.saveNewSuccess, this.saveNewError)
        }
      }
    },
    props: {
      palbearersAmount: {
        required: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppAddBookingButton.vue?2bde7509